import Environment from '../constants/Environment';

const HOST_BY_ENVIRONMENT: {[x in Environment]?: string} = {
  [Environment.DEVELOPMENT]: 'localhost',
  [Environment.SANDBOX]: 'sandbox-ezcater.com',
  [Environment.STAGING]: 'staging-ezcater.com',
};

interface WindowWithOptionalOrigin {
  location?: {
    origin?: string;
  };
}

export const getEnvironment = (currentWindow?: WindowWithOptionalOrigin): Environment => {
  const environments = Object.keys(Environment).map(
    (key: string) => Environment[key as keyof typeof Environment]
  );

  const matchingEnvironment = environments.filter((environment: Environment) => {
    const host = HOST_BY_ENVIRONMENT[environment];
    const origin = currentWindow?.location?.origin;

    return host && origin ? origin.indexOf(host) !== -1 : null;
  })[0];

  return matchingEnvironment || Environment.PRODUCTION;
};

export default getEnvironment;
